import { forwardRef, ReactNode } from 'react';

import { Card, Title, useBreakpoint } from '@hh.ru/magritte-ui';

import BlurryCardContent from 'src/components/BlurryCardContent';
import { ProfessionAreaChartItem } from 'src/models/pages/profession';

import Chart from 'src/pages/Profession/components/SectionStatistics/AreaChart/Chart';

import styles from './styles.less';

interface Props {
    title: string;
    description?: string;
    data: ProfessionAreaChartItem[];
    initValue: ProfessionAreaChartItem;
    blurred: boolean;
    aboveContent: ReactNode;
    'data-qa'?: string;
    onChartClick: () => void;
}

const AreaChart = forwardRef<HTMLDivElement, Props>(
    ({ title, description, data, initValue, aboveContent, blurred, onChartClick, 'data-qa': dataQa }, ref) => {
        const { isMobile } = useBreakpoint();

        const borderRadius = isMobile ? 16 : 24;

        return (
            <Card borderRadius={borderRadius} showBorder stretched data-qa={dataQa} ref={ref}>
                <BlurryCardContent
                    blurred={blurred}
                    padding={isMobile ? 16 : 24}
                    borderRadius={borderRadius}
                    aboveContent={aboveContent}
                >
                    <div className={styles.container}>
                        <Title size={isMobile ? 'small' : 'medium'} Element="h2" description={description}>
                            {title}
                        </Title>
                        <Chart data={data} initValue={initValue} onClick={onChartClick} />
                    </div>
                </BlurryCardContent>
            </Card>
        );
    }
);

export default AreaChart;
